import {
  FETCH_AMIGO_PAGUITOS_LOAN_DETAILS,
  FETCH_AMIGO_PAGUITOS_LOAN_DETAILS_SUCCESS,
  FETCH_AMIGO_PAGUITOS_LOAN_DETAILS_ERROR,
  FETCH_AMIGO_PAGUITOS_LOAN_DETAILS_RESET,
} from "../actions/aploan";

const initialState = {
  loading: false,
  status: undefined,
  data: {},
  err: undefined,
};

export default function aploanReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_AMIGO_PAGUITOS_LOAN_DETAILS:
      return { ...state, loading: true, err: undefined };

    case FETCH_AMIGO_PAGUITOS_LOAN_DETAILS_SUCCESS:
      console.log("action reducer", action);
      return {
        ...state,
        loading: false,
        status: action.payload.status,
        data: action.payload.data,
        cuotas: action.payload.cuotas,
        err: undefined,
        detail: action.payload.detail,
        dueDate: action.payload.dueDate,
        expirationDate: action.payload.expirationDate,
        maxAmount: action.payload.maxAmount,
        reference: action.payload.reference,
        periodicity: action.payload.periodicity,
        pendingAmount: action.payload.pendingAmount,
        model: action.payload.model,
        brand: action.payload.brand,
      };

    case FETCH_AMIGO_PAGUITOS_LOAN_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        err: action.err,
        data: action.payload,
      };
    case FETCH_AMIGO_PAGUITOS_LOAN_DETAILS_RESET:
      return { ...initialState };

    default:
      return { ...state };
  }
}
